<template>
  <Customloading v-if="loading" />
  <div
    class="modal fade"
    id="ModalLoginForm"
    tabindex="-1"
    aria-labelledby="ModalLoginFormLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered" id="ModalGetOTP">
      <div class="modal-content">
        <div class="modal-header border border-0 mt-3">
          <button
            type="button"
            id="dismiss-modal"
            class="btn-close p-1 m-4"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <div class="modal-body rounded">
          <div class="myform modal-body">
            <div class="text-center">
              <img
                :src="`${config.public.logo}`" width="75%"
                alt=""
              />
            </div>
            <!-- Menyembunyikan dan Menampilkan Modal Form Login -->
            <div v-show="mode == '1' && !resetPasswordPage && !showOtpReset" class="form">
              <form @submit.prevent="signIn">
                <div
                  class="alert alert-danger mb-2"
                  v-if="signInErrorMsg"
                  role="alert"
                >
                  {{ signInErrorMsg }}
                </div>
                <div class="mb-3 mt-4">
                  <label for="phone" class="form-label">
                    <i class="fa-solid fa-phone me-2 text-primary"></i>Nomor Telepon
                  </label>
                  <input
                    v-model="memberPhone"
                    type="tel"
                    class="form-control"
                    id="phone"
                    name="phone"
                    aria-describedby="emailHelp"
                    placeholder="Masukkan nomor telepon..."
                    required
                  />
                </div>
                <button
                  :disabled="loading"
                  type="submit"
                  class="btn btn-primary border-2 rounded-3 mt-3 fw-medium"
                >
                  Login <i class="fa-solid fa-right-to-bracket"></i>
                </button>
              </form>
              <!-- <button type="submit" class="btn btn-light mt-3">LOGIN</button> -->
              <!-- <p>Not a member? <a href="#">Signup now</a></p> -->
            </div>
            <!-- Menyembunyikan dan Menampilkan Modal Form OTP -->
            <div v-show="mode == '2' && !resetPasswordPage && !showOtpReset" class="form">
              <div
                class="alert alert-danger mb-2"
                v-if="signInErrorMsg"
                role="alert"
              >
                {{ signInErrorMsg }}
              </div>
              <div class="mb-3 mt-4">
                <div class="text-center">
                  <label for="digit" class="text-center"
                    >Masukkan kode OTP yang kami kirim ke :</label
                  >
                </div>
                <div class="text-center">
                  <label for="" class="form-label fw-bolder">
                    {{
                      receiverOTPvia == 'email'
                        ? formatEmail(receiverOTP)
                        : receiverOTP.replace(/.*(?=\d{3}$)/, '*******')
                    }}
                  </label>
                </div>
              </div>
              <div
                class="alert alert-danger mb-3"
                v-if="otpErrorMsg"
                role="alert"
              >
                {{ otpErrorMsg }}
              </div>

              <div class="mb-3">
                <section class="wrapper">
                  <div class="container">
                    <div class="otp_input text-center mb-2">
                      <label for="otp" class="form-label fw-bolder"
                        >Masukkan Kode OTP</label
                      >
                      <div
                        class="d-flex align-items-center justify-content-between mt-2"
                      >
                        <input
                          v-for="(digit, index) in memberOTP"
                          :key="index"
                          v-model="memberOTP[index]"
                          @input="handleOTPInput(index)"
                          @keydown.backspace.prevent="handleBackspace(index)"
                          @paste="handlePaste($event,'memberOTP')"
                          type="text"
                          :id="`otpInput${index}`"
                          class="form-control-otp"
                          placeholder=""
                          maxlength="1"
                          ref="otpInput"
                        />
                      </div>
                    </div>
                    <div class="fw-normal text-muted mt-2 text-center">
                      Belum dapat kode?
                      <a
                        @click="signIn"
                        v-if="countdownTimer <= 0"
                        class="text-primary fw-bold text-decoration-none"
                        style="cursor:pointer;"
                      >
                        Kirim ulang
                      </a>
                      <span class="fw-bold cursor-pointer  text-secondary text-decoration-none" v-if="countdownTimer > 0">Kirim ulang</span>
                      <span class="text-danger" v-if="countdownTimer > 0"
                        >({{ countdownTimerInMinutes }})</span
                      >
                    </div>
                  </div>
                </section>
              </div>
            </div>
            <div class="form" v-if="showOtpReset">
              <div class="mb-3 mt-4">
                <div class="text-center">
                  <label for="digit" class="text-center"
                    >Masukkan kode OTP yang kami kirim ke email</label
                  >
                </div>
              </div>

              <div class="mb-3">
                <section class="wrapper">
                  <div class="container">
                    <div class="otp_input text-center mb-2">
                      <label for="otp" class="form-label fw-bolder"
                        >Masukkan Kode OTP</label
                      >
                      <div
                        class="d-flex align-items-center justify-content-between mt-2"
                      >
                        <input
                          v-for="(digit, index) in otpReset"
                          :key="index"
                          v-model="otpReset[index]"
                          @input="handleOTPReset(index)"
                          @keydown.backspace.prevent="handleBackspaceReset(index)"
                           @paste="handlePaste($event,'otpReset')"
                          type="text"
                          :id="`otpInputReset${index}`"
                          class="form-control-otp"
                          placeholder=""
                          maxlength="1"
                          ref="otpResetInput"
                        />
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted } from "vue";
import { useUserStore } from "~/stores/user";
import Swal from "sweetalert2";

const userStore = useUserStore();
const airline = useAirlinesStore();
const train = useTrainStore();
const pelni = usePelniStore();
const passenger = usePassengersStore()
const localStorageStore = useLocalStorageStore();
const config = useRuntimeConfig();
const mode = ref("1"); // Modal default yang ditampilkan adalah modalId 1 (Modal Form Login)
const memberPhone = ref("");
const memberPassword = ref("");
const memberOTP = ref(["", "", "", "", "", ""]); // Array untuk menyimpan karakter dari setiap input OTP
const otpReset = ref(["", "", "", "", "", ""]);
const otpErrorMsg = ref(""); //save error msg from otp request
const signInErrorMsg = ref(""); //save error msg from signin request
let responseData: any; //save data exp otp
const showPassword = ref(false);
const deviceId = ref("");
const loading = ref(false);
const otpInput = ref([]);
const otpResetInput = ref([]);
const resetPasswordPage = ref(false)
const showOtpReset = ref(false)
const username = ref("")
const email = ref("")
const fcmToken = ref(localStorageStore.getFCMToken() ?? "");
const receiverOTP = ref("")
const receiverOTPvia = ref("")


const showPass = () => {
  if(showPassword.value === true){
    showPassword.value = false
  }else if(showPassword.value === false){
    showPassword.value = true
  }
}
//countdown
const calculateCountdown = () => {
  const expiredTime = new Date(responseData?.expired).getTime();
  const serverTime = new Date(responseData?.time_server).getTime();
  const currentTime = new Date().getTime();

  const timeRemaining = Math.floor(
    (expiredTime - serverTime - (currentTime - serverTime)) / 1000
  );

  return Math.max(0, timeRemaining);
};
//minute formating
const calculateCountdownInMinutes = () => {
  const secondsRemaining = calculateCountdown();
  const minutes = Math.floor(secondsRemaining / 60);
  const seconds = secondsRemaining % 60;
  return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
};

const countdownTimerInMinutes = ref(calculateCountdownInMinutes());

const countdownTimer = ref(calculateCountdown());
let countdownInterval: any;


watch(mode, (newVal) => {
  if (newVal === '2') {
    nextTick(() => {
      if (otpInput.value.length > 0) {
        otpInput.value[0].focus();
      }
    });
  }
});

watch(showOtpReset,(newVal) => {
  if(newVal == true){
    nextTick(() => {
      if (otpResetInput.value.length > 0) {
        otpResetInput.value[0].focus();
      }
    });
  }
})

const focusOnInput = (index: number) => {
  const nextInput = document.getElementById(`otpInput${index}`);
  if (nextInput) {
    nextInput.focus();
  }
};

const focusOnInputReset = (index: number) => {
  const nextInput = document.getElementById(`otpInputReset${index}`);
  if (nextInput) {
    nextInput.focus();
  }
};

const handleBackspace = (index: number) => {
  if (memberOTP.value[index] === '' && index > 0) {
    const prevIndex = index - 1;
    memberOTP.value[prevIndex] = '';
    focusOnInput(prevIndex);
  } else if (memberOTP.value[index] !== '') {
    memberOTP.value[index] = '';
  }
};

const handleBackspaceReset = (index: number) => {
  if (otpReset.value[index] === '' && index > 0) {
    const prevIndex = index - 1;
    otpReset.value[prevIndex] = '';
    focusOnInputReset(prevIndex);
  } else if (otpReset.value[index] !== '') {
    otpReset.value[index] = '';
  }
};

onMounted(() => {
  // Kolom yang pertama kali dipilih untuk diisi secara default
  focusOnInput(0);
  focusOnInputReset(0)
  deviceId.value = userStore.deviceId();
  // countdownInterval = setInterval(() => {
  //   countdownTimer.value = calculateCountdown();
  //   countdownTimerInMinutes.value = calculateCountdownInMinutes();

  //   // Hentikan countdown jika mencapai 0
  //   if (countdownTimer.value <= 0) {
  //     clearInterval(countdownInterval);
  //   }
  // }, 1000);
});

const handleOTPInput = (index: number) => {
  if (memberOTP.value[index].length === 1) {
    // Jika max value terpenuhi, maka otomatis lanjut ke value berikutnya
    const nextIndex = index + 1;
    if (nextIndex < memberOTP.value.length) {
      focusOnInput(nextIndex);
    } else {
      loading.value = true
      // Jika ingin langsung submit, tapi modal masih nyangkut
      submitOTP();
    }
  }
};

const handleOTPReset = (index: number) => {
  if (otpReset.value[index].length === 1) {
    // Jika max value terpenuhi, maka otomatis lanjut ke value berikutnya
    const nextIndex = index + 1;
    if (nextIndex < otpReset.value.length) {
      focusOnInputReset(nextIndex);
    } else {
      reset();
    }
  }
};

const handlePaste = (event: ClipboardEvent, type: string) => {
  const pasteData = event.clipboardData?.getData('text').trim() || '';

  // Pilih array OTP dan referensi input yang benar berdasarkan tipe
  const otp = type === 'memberOTP' ? memberOTP.value : otpReset.value;
  const ref = type === 'memberOTP' ? otpInput.value : otpResetInput.value;

  // Pastikan panjang data sesuai jumlah OTP
  if (pasteData.length === otp.length) {
    // Isi masing-masing input dengan karakter yang di-paste
    otp.forEach((_, index) => {
      otp[index] = pasteData[index];
    });

    // Update nilai array OTP berdasarkan tipe
    if (type === 'memberOTP') {
      memberOTP.value = otp;
    } else {
      otpReset.value = otp;
    }

    
    ref[otp.length - 1]?.focus();
  }
};




const getDeviceType = () => {
  // const userAgent = navigator.userAgent.toLowerCase();

  // if (
  //   userAgent.includes("mobile") ||
  //   userAgent.includes("android") ||
  //   userAgent.includes("iphone") ||
  //   userAgent.includes("ipad")
  // ) {
  //   return "mobile";
  // } else {
  //   return "desktop";
  // }
  
  return "web";
};

const getDeviceOS = () => {
  const userAgent = navigator.userAgent.toLowerCase();

  if (userAgent.includes("windows")) {
    return "Windows";
  } else if (userAgent.includes("macintosh") || userAgent.includes("mac os")) {
    return "Mac";
  } else if (userAgent.includes("android")) {
    return "Android";
  } else if (userAgent.includes("iphone") || userAgent.includes("ipad")) {
    return "iOS";
  } else if (userAgent.includes("linux")) {
    return "Linux";
  } else {
    return "Unknown";
  }
};

const resetCountdown = () => {
  countdownTimer.value = calculateCountdown(); // Reset the countdown
  countdownTimerInMinutes.value = calculateCountdownInMinutes(); // Reset the countdown display

  // Clear any existing interval before starting a new one
  clearInterval(countdownInterval);
  countdownInterval = setInterval(() => {
    countdownTimer.value = calculateCountdown();
    countdownTimerInMinutes.value = calculateCountdownInMinutes();

    // Hentikan countdown jika mencapai 0
    if (countdownTimer.value <= 0) {
      clearInterval(countdownInterval);
    }
  }, 1000);
};

const  formatEmail = (email:String) =>  {
  const [name, domain] = email.split('@');
  if (name.length <= 4) {
    // Jika nama pendek
    return `${name[0]}***${name[name.length - 1]}@${domain}`;
  } else {
    // Jika nama panjang
    return `${name.slice(0, 2)}*******${name.slice(-2)}@${domain}`;
  }

}
// const fcmToken = localStorage.getItem('fcmToken');

const checkIfUserPinSet = async () => {
  try {
    const response = await userStore.checkPin();
    if (response?.status.code == 200 && response.details.required.user == 'set_pin') {

      localStorage.setItem(`isPinSet${userStore.user?.id}`, false);

      const modal = document.getElementById('settingPinModal')
      if(modal){
        const modalInstance = new bootstrap.Modal(modal, {
          keyboard: false,
          backdrop: 'static'
        })
        modalInstance.show();
      }
    }else if(response?.status.code == 200 && response.details.required.user == null){
      localStorage.setItem('isPinSet', true);
    }
  } catch (error) {
    console.error("Terjadi kesalahan saat mengecek status pin:", error);
  }
}

const signIn = async () => {
  try {
    loading.value = true;
    memberOTP.value = ["", "", "", "", "", ""]; 
    signInErrorMsg.value = null || "";
    const response = await userStore.signIn({
      grant_type: "login",
      version: "1.0.0",
      member_phone: memberPhone.value,
      device_id: deviceId.value,
      device_type: getDeviceType(),
      device_os: getDeviceOS(),
      device_name: navigator.appCodeName,
      notif_id: fcmToken.value,
    });

    console.log(fcmToken.value);

    if (response?.status.code == 200) {
      memberPhone.value = "";
      memberPassword.value = "";
      signInErrorMsg.value = null || "";
      Swal.fire({
        title: "Login Berhasil",
        icon: "success",
      });

      
      const isPinSet = localStorage.getItem(`isPinSet${response.details.user?.id}`);
      
      if(isPinSet){
        if(isPinSet == 'false'){
          await checkIfUserPinSet();
        }
      }else{
        await checkIfUserPinSet();
      }

      const contact =  await userStore.getInfoContact();
      userStore.saveToLocalStorage('addreses', contact)
      
      const domAirports =  await airline.getDomesticAirport()
      const intAirports = await airline.getInternationalAirport()
      const stations = await train.getStations();
      const harbours = await pelni.getPelabuhan();
      const passengers = await passenger.getPassengers();
      const airlinesCode = await airline.getAirlinesCode();


      // Store the results in local storage
      userStore.saveToLocalStorage('domesticAirports', domAirports);
      userStore.saveToLocalStorage('internationalAirports', intAirports);
      userStore.saveToLocalStorage('stations', stations);
      userStore.saveToLocalStorage('passengers',passengers);
      userStore.saveToLocalStorage('harbours', harbours);
      userStore.saveToLocalStorage('airlines_code', airlinesCode);

      document.getElementById('dismiss-modal').click();

    }else if (response?.status.code == 403 || response?.status.code == 401) {
      // Jika Username/No.Telp dan Password sesuai maka lanjut membuka form berikutnya (Form OTP)

      mode.value = "2"; // Menampilkan Form OTP
      responseData = response.details.otp;
      receiverOTP.value = response.details.otp.receiver;
      receiverOTPvia.value = response.details.otp.via;

      clearInterval(countdownInterval);
      countdownTimer.value = calculateCountdown();
      countdownTimerInMinutes.value = calculateCountdownInMinutes();
      resetCountdown()
      // countdownTimer.value = calculateCountdown();
    } else if (response?.status.code === 400) {
      // Jika Username/No.Telp dan Password salah maka masukkan ulang (Kembali ke index)
      memberPhone.value = "";
      memberPassword.value = "";
      signInErrorMsg.value = `${response?.status.message}`;
      // await navigateTo("/", { replace: true });
    } else {
      // Jika Username/No.Telp dan Password salah maka masukkan ulang (Kembali ke index)
      memberPhone.value = "";
      memberPassword.value = "";
      signInErrorMsg.value = `${response?.status.message}`;
    }
  } catch (error) {
    signInErrorMsg.value = "Terjadi kesalahan saat login:";
    console.error("Terjadi kesalahan saat login:", error);
  }finally{
    loading.value = false;
  }
};

const submitOTP = async () => {
  try {
    loading.value = true;
    const response = await userStore.submitOTP({
      grant_type: "login",
      version: "1.0.0",
      member_phone: memberPhone.value,
      device_id: deviceId.value,
      device_type: getDeviceType(),
      device_os: getDeviceOS(),
      device_name: navigator.appCodeName,
      otp: memberOTP.value.join(""), // Mengakses value dari Ref dan kemudian menggunakan join
      via: "email",
      notif_id: fcmToken.value,
    });

    if (response?.status.code == 200) {
      // Jika OTP sudah benar maka akan langsung diarahkan ke Dashboard
      // document.getElementById("ModalLoginForm").modal('hide');
      // modal.hide();
      mode.value = "1"; // Close the modal
      memberOTP.value = ["", "", "", "", "", ""];
      memberPhone.value = "";
      memberPassword.value = "";
      signInErrorMsg.value = null || "";
      Swal.fire({
        title: "Login Success",
        icon: "success",
      });

      const isPinSet = localStorage.getItem(`isPinSet${response.details.user?.id}`);
      
      if(isPinSet){
        if(isPinSet == 'false'){
          await checkIfUserPinSet();
        }
      }else{
        await checkIfUserPinSet();
      }

      document.getElementById('dismiss-modal').click();
    } else if (response?.status.code == 403) {
      otpErrorMsg.value = `${response?.status.message}`;
      memberOTP.value = ["", "", "", "", "", ""];
    }
  } catch (error) {
    otpErrorMsg.value =
    "Terjadi kesalahan saat mengirim dan memverifikasi OTP:";
    console.error(
      "Terjadi kesalahan saat mengirim dan memverifikasi OTP:",
      error
    );
  }finally{
    loading.value = false;
  }
};

const forgotPassword = async () => {
  try {
    loading.value = true;
    const response: any = await userStore.forgotPassword({
      username: username.value,
      email: email.value,
      via: 'email'
    })

    if(response?.status.code == 403 || response?.status.code == 401){
      showOtpReset.value = true
      focusOnInputReset(0)
    }else{
      Swal.fire({
        icon: 'error',
        title: 'Eror',
        text: 'Terjadi kesalahan saat mengirim OTP:',
      })
    }
  } catch (error) {
    console.error(error)
  }finally{
    loading.value = false;
  }
}

const reset = async() => {
  try {
    loading.value = true;
    const response: any = await userStore.forgotPassword({
      username: username.value,
      email: email.value,
      via: 'email',
      otp: otpReset.value.join(""),
    })

    if (response?.status.code == 200) {
      otpReset.value = ["", "", "", "", "", ""];
      Swal.fire({
        title: "Reset Success",
        icon: "success",
      });
      showOtpReset.value = false
      resetPasswordPage.value = false
      document.getElementById('dismiss-modal').click();
    } else{
      Swal.fire({
        title: "Reset Failed",
        icon: "Error",
        message: `${response?.status.message}`,
      });
      showOtpReset.value = false
      resetPasswordPage.value = false
      document.getElementById('dismiss-modal').click();
      otpReset.value = ["", "", "", "", "", ""];
    }
  } catch (error) {
    console.error(error)
  }finally{
    loading.value = false;
    username.value = '';
    email.value = ''
  }
}
</script>

<style scoped>
.modal-content {
  width: 80%;
  margin: 0 auto;
}
.modal-body {
  padding: 0;
}
.btn-close {
  position: absolute;
  right: 0;
  padding: 1em;
}
h1 {
  font-size: 2.3em;
  font-weight: bold;
}
.myform {
  padding: 2em;
  max-width: 100%;
  color: #114777;
}
.myform .form-control {
  background-color: inherit;
  color: #114777;
  padding-left: 0;
  border: 0;
  border-radius: 0;
  border-bottom: 1px solid #114777;
}
.form-control::placeholder {
  color: #114777;
  font-size: 14px;
}
@media (max-width: 576px) {
  .myform {
    max-width: 90%;
    margin: 0 auto;
  }
}
.form-control:focus {
  box-shadow: inset 0 -1px 0 #7e7e7e;
}
.form-control {
  background-color: inherit;
  color: #114777;
  padding-left: 0;
  border: 0;
  border-radius: 0;
  border-bottom: 1px solid #114777;
}
.myform .btn {
  width: 100%;
  font-weight: 800;
  background-color: #114777;
  border-radius: 0;
  padding: 0.5em 0;
}
.myform .btn:hover {
  background-color: inherit;
  color: white;
  border-color: #114777;
}
p {
  text-align: center;
  padding-top: 2em;
  color: grey;
}
p a {
  color: #114777;
  text-decoration: none;
}
p a:hover {
  color: #114777;
}

/* Main CSS OTP Verification New Changing */
.wrapper {
  background-position: bottom center;
  background-repeat: no-repeat;
  background-size: contain;
  background-attachment: fixed;
  min-height: 100%;
  /* height:100vh;
    display:flex;
    align-items:center;
    justify-content:center; */
}
.wrapper .logo img {
  max-width: 40%;
}
.wrapper input {
  background-color: #f0f0f0;
  border: 0;
  border-color: #f0f0f0;
  border-radius: 6px;
  color: var(--gray);
}
.wrapper input:focus {
  box-shadow: none;
}

/* OTP Verification CSS */
.wrapper .otp_input input {
  width: 14%;
  height: 50px;
  text-align: center;
  font-size: 20px;
  font-weight: 600;
}

@media (max-width: 1200px) {
  .wrapper .otp_input input {
    height: 50px;
  }
}
@media (max-width: 767px) {
  .wrapper .otp_input input {
    height: 40px;
  }
}
</style>